import apiService from '@/api/apiService';

export const getOperationLogs = (params = {}) =>
    apiService.GET('/api/admin/operation-logs', params);

export const getOperationLogMeta = () =>
    apiService.GET('/api/admin/operation-logs/meta');
